// extracted by mini-css-extract-plugin
module.exports = {"fullLoadScreen":"loadScreen_fullLoadScreen__3Mdeq"};